import { render, staticRenderFns } from "./SelectTags.vue?vue&type=template&id=ad480adc&scoped=true&"
import script from "./SelectTags.vue?vue&type=script&lang=ts&"
export * from "./SelectTags.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTags.vue?vue&type=style&index=0&id=ad480adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad480adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet,VSpacer})
